export const createLog = (title, logs) => {
  if (import.meta.env.DEV) {
    console.error(`[${title}]`, logs);
  }
};
